module.exports = __webpack_public_path__ + "img/portraits_07_V.4675ae8f.webp";